import React from 'react';
import { GREEN, BLACK } from '../constants';
import { F, labelSt, inputSt } from '../styles';

export function Btn({ children, onClick, v = 'green', sm, dis }) {
  const variants = {
    green:   { background: GREEN, color: BLACK, border: 'none' },
    black:   { background: BLACK, color: '#fff', border: 'none' },
    outline: { background: '#fff', color: BLACK, border: '1.5px solid #ddd' },
    danger:  { background: '#fee2e2', color: '#dc2626', border: 'none' },
  };
  const s = variants[v] || variants.green;
  return (
    <button
      onClick={dis ? undefined : onClick}
      style={{
        ...s,
        borderRadius: 9, fontWeight: 700,
        cursor: dis ? 'default' : 'pointer',
        fontSize: sm ? 12 : 13,
        padding: sm ? '5px 12px' : '8px 18px',
        opacity: dis ? 0.5 : 1,
        fontFamily: F,
        display: 'inline-block',
      }}
    >
      {children}
    </button>
  );
}

export function TextInput({ label, value, onChange, ph, type = 'text', multi, readOnly }) {
  return (
    <div>
      {label && <div style={labelSt}>{label}</div>}
      {multi
        ? (
          <textarea
            value={value} onChange={onChange} placeholder={ph} rows={3}
            style={{ ...inputSt(readOnly), resize: 'vertical' }} readOnly={readOnly}
          />
        ) : (
          <input
            type={type} value={value} onChange={onChange} placeholder={ph}
            style={inputSt(readOnly)} readOnly={readOnly}
          />
        )
      }
    </div>
  );
}

export function Modal({ children, onClose }) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 999, padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 16, padding: 26,
          width: 480, maxWidth: '96vw',
          boxShadow: '0 20px 50px rgba(0,0,0,.2)',
          maxHeight: '90vh', overflowY: 'auto', fontFamily: F,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export function NavBar({ title, sub, onBack, right }) {
  return (
    <div style={{
      background: '#fff', borderBottom: '1.5px solid #e0e0d8',
      padding: '0 22px', height: 54,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      position: 'sticky', top: 0, zIndex: 100, fontFamily: F,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {onBack && (
          <button onClick={onBack} style={{
            background: '#f5f5f2', border: '1.5px solid #e0e0d8',
            borderRadius: 7, width: 30, height: 30, cursor: 'pointer', fontSize: 14,
          }}>{'<'}</button>
        )}
        <div style={{
          width: 26, height: 26, background: GREEN, borderRadius: 6,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 900, fontSize: 13,
        }}>A</div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 13 }}>{title}</div>
          {sub && <div style={{ fontFamily: 'monospace', fontSize: 11, color: '#999' }}>{sub}</div>}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>{right}</div>
    </div>
  );
}

export function ProgressBar({ pct, color }) {
  return (
    <div style={{ background: '#f0f0ec', borderRadius: 100, height: 5 }}>
      <div style={{ width: `${pct}%`, background: color || GREEN, borderRadius: 100, height: '100%' }} />
    </div>
  );
}

export function StatusBadge({ done, label }) {
  return (
    <span style={{
      background: done ? GREEN : '#f0f0ec',
      color: done ? BLACK : '#555',
      padding: '3px 9px', borderRadius: 20, fontSize: 11, fontWeight: 700,
    }}>{label}</span>
  );
}
